(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-accordion"] && !Shopify.designMode) return;
  try {
    class customAccordion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-faq-button]');
      if (this.button) {
        this.setupToggle();
        this.checkAutoOpen();
      }
    }

    checkAutoOpen() {
      if (this.dataset.autoopen === 'true') {
        this.open();
      }
    }

    setupToggle() {
      this.button.addEventListener('click', () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? this.close() : this.open();
      });
    }

    open() {
      this.button.setAttribute('aria-expanded', 'true');
      this.button.nextElementSibling.classList.add('active');
    }

    close() {
      this.button.setAttribute('aria-expanded', 'false');
      this.button.nextElementSibling.classList.remove('active');
    }
  }

  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', customAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-showcase"] && !Shopify.designMode) return;
  try {
    class CustomShowcase extends HTMLElement {
    connectedCallback() {
      this.featuredImage = this.querySelector('[data-featured-image]');
      this.featuredInfo  = this.querySelector('[data-featured-info]');
      this.featuredTitle = this.querySelector('[data-featured-title]');
      this.thumbnails    = this.querySelectorAll('[data-thumbnail]');

      this.setupEventListeners();

      if (this.thumbnails.length > 0) {
        this.handleThumbnailClick(this.thumbnails[0]);
      }
    }

    setupEventListeners() {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          this.handleThumbnailClick(thumbnail);
        });
      });
    }

    handleThumbnailClick(thumbnail) {
      const { imageUrl, imageAlt, imageWidth, imageHeight, imageInfo, imageTitle } = thumbnail.dataset;

      if (this.featuredImage && imageUrl) {
        this.featuredImage.src       = imageUrl;
        this.featuredImage.alt       = imageAlt;
        this.featuredImage.width     = imageWidth;
        this.featuredImage.height    = imageHeight;
        this.featuredInfo.innerHTML  = imageInfo;
        this.featuredTitle.innerHTML = imageTitle;

        this.thumbnails.forEach(thumb => thumb.classList.remove('active'));
        thumbnail.classList.add('active');

        this.querySelector('.showcase__featured').scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  }

  if (!customElements.get('showcase-gallery')) {
    customElements.define('showcase-gallery', CustomShowcase);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-styled-heading"] && !Shopify.designMode) return;
  try {
    (function() {
    /*
      Insert a <br> before or after <em> depending on content order.
      The brInserted guard prevents double-processing if this somehow runs again.
    */
    const headings = document.querySelectorAll('.styled-heading-line[data-line-break]');

    headings.forEach((heading) => {
      if (heading.dataset.brInserted === 'true') return;

      const em = heading.querySelector('em');
      if (!em) return;

      const br = document.createElement('br');
      const childNodes = Array.from(heading.childNodes);
      const emIndex = childNodes.indexOf(em);

      const hasTextBefore = childNodes
        .slice(0, emIndex)
        .some(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '');

      if (hasTextBefore) {
        heading.insertBefore(br, em);
      } else {
        em.insertAdjacentElement('afterend', br);
      }

      heading.dataset.brInserted = 'true';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
